var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-file", {
    attrs: {
      state: Boolean(_vm.file),
      placeholder: "Выберите файл",
      "drop-placeholder": "Перенесите файл сюда..."
    },
    on: { change: _vm.change },
    model: {
      value: _vm.file,
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }